/**
 * 运营 - 自由职业者管理 - 自由职业者列表
 */
<template>
  <div class="freelancer-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者管理</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="姓名">
          <el-input
            v-model="formInline.name"
            placeholder="请输入姓名"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="证件号">
          <el-input
            v-model="formInline.idNumber"
            placeholder="请输入证件号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="formInline.mobile"
            placeholder="请输入手机号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="收款账号">
          <el-input
            v-model="formInline.receiveAccount"
            placeholder="请输入收款账号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="商户">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.distributeCompanyName"
            placeholder="请输入服务商名称"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="签约状态">
          <el-select
            v-model="formInline.signStatus"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option
              v-for="item in signStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="人脸认证状态">
          <el-select
            v-model="formInline.faceAuthStatus"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option
              v-for="item in faceAuthStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="formInline.signDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="search-date"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="batch-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-edit-outline"
        @click="openBatchUpdateDialog"
      >批量修改</el-button>
      <el-button
        type="danger"
        size="small"
        icon="el-icon-delete"
        :loading="batchDeleting"
        @click="handleBatchDelete"
      >批量删除</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        ref="freelancerTable"
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无自由职业者"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column prop="freelancerName" label="姓名" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.freelancerName)"
            >
              {{ scope.row.freelancerName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="identityDocumentTypeStr" label="证件类型" min-width="120" show-overflow-tooltip />
        <el-table-column prop="identityDocumentNumber" label="证件号" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.identityDocumentNumber)"
            >
              {{ scope.row.identityDocumentNumber || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.mobile)"
            >
              {{ scope.row.mobile || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="receiveAccount" label="收款账号" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.receiveAccount)"
            >
              {{ scope.row.receiveAccount || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="verificationStatusStr" label="实名认证状态" min-width="120">
          <template slot-scope="scope">
            <span :style="{ color: getVerificationStatusColor(scope.row.verificationStatus) }">
              {{ scope.row.verificationStatusStr || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="signStatusStr" label="签约状态" min-width="110">
          <template slot-scope="scope">
            <span :style="{ color: getSignStatusColor(scope.row.signStatus) }">
              {{ scope.row.signStatusStr || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="identityPhoto" label="证件照片" min-width="100">
          <template slot-scope="scope">
            <el-tag
              size="small"
              effect="plain"
              :type="scope.row.identityPhoto === '已上传' ? 'success' : 'info'"
            >
              {{ scope.row.identityPhoto || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="faceAuthStatusStr"
          label="人脸认证状态"
          min-width="110"
        >
          <template slot-scope="scope">
            <span :style="{ color: getFaceAuthStatusDisplayColor(scope.row) }">
              {{ getFaceAuthStatusDisplayText(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="merchantName" label="商户" min-width="140" show-overflow-tooltip />
        <el-table-column prop="distributeCompanyName" label="服务商" min-width="140" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
        <el-table-column prop="contractSignAtStr" label="签约时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contractSignAtStr || formatDateTime(scope.row.contractSignAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="createdAtStr" label="创建时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createdAtStr || formatDateTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedAtStr" label="更新时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.updatedAtStr || formatDateTime(scope.row.updatedAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              plain
              @click="handleEdit(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="primary"
              size="mini"
              plain
              :loading="scope.row.faceAuthLoading"
              @click="handleFaceAuth(scope.row)"
            >
              补录人脸
            </el-button>
            <el-button
              type="danger"
              size="mini"
              plain
              :loading="scope.row.deleting"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>

    <el-dialog
      title="人脸认证链接"
      :visible.sync="faceAuthDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div v-if="faceAuthLink" class="face-auth-success">
        <p class="face-auth-tip">请将以下链接转发给自由职业者本人，在手机浏览器中打开完成人脸认证：</p>
        <el-input
          :value="faceAuthLink"
          type="textarea"
          :rows="3"
          readonly
          resize="none"
          class="face-auth-link-input"
        />
      </div>
      <div v-else class="face-auth-error">
        <p class="face-auth-error-msg">{{ faceAuthError || '获取人脸认证链接失败' }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="faceAuthDialogVisible = false">关 闭</el-button>
        <el-button
          v-if="faceAuthLink"
          type="primary"
          size="small"
          @click="handleCopyFaceAuthLink"
        >复制链接</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改自由职业者"
      :visible.sync="editDialogVisible"
      width="720px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="110px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商户">
              <el-input :value="editForm.merchantName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商">
              <el-input :value="editForm.distributeCompanyName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="姓名" prop="freelancerName">
              <el-input v-model="editForm.freelancerName" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="identityDocumentType">
              <el-select v-model="editForm.identityDocumentType" placeholder="请选择证件类型" style="width: 100%">
                <el-option
                  v-for="item in idTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="证件号" prop="identityDocumentNumber">
              <el-input v-model="editForm.identityDocumentNumber" placeholder="请输入证件号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="editForm.mobile" placeholder="请输入手机号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="收款账号" prop="receiveAccount">
              <el-input v-model="editForm.receiveAccount" placeholder="请输入收款账号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实名认证状态" prop="verificationStatus">
              <el-select v-model="editForm.verificationStatus" placeholder="请选择实名认证状态" style="width: 100%">
                <el-option
                  v-for="item in verificationStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="认证照片">
          <div class="identity-photo-area">
            <div class="identity-photo-item">
              <div class="identity-photo-label">人面像</div>
              <el-image
                v-if="editForm.identityPhoto1Url"
                :src="editForm.identityPhoto1Url"
                fit="cover"
                class="identity-photo-thumb"
                :preview-src-list="[editForm.identityPhoto1Url]"
              />
              <div v-else class="identity-photo-empty">暂无照片</div>
              <el-button
                size="mini"
                type="primary"
                plain
                :loading="identityPhotoUploading1"
                @click="pickIdentityPhoto(1)"
              >选取照片</el-button>
              <input
                ref="identityPhotoInput1"
                type="file"
                accept=".jpg,.jpeg,.png"
                style="display: none"
                @change="onIdentityPhotoPicked($event, 1)"
              />
            </div>
            <div class="identity-photo-item">
              <div class="identity-photo-label">国徽面</div>
              <el-image
                v-if="editForm.identityPhoto2Url"
                :src="editForm.identityPhoto2Url"
                fit="cover"
                class="identity-photo-thumb"
                :preview-src-list="[editForm.identityPhoto2Url]"
              />
              <div v-else class="identity-photo-empty">暂无照片</div>
              <el-button
                size="mini"
                type="primary"
                plain
                :loading="identityPhotoUploading2"
                @click="pickIdentityPhoto(2)"
              >选取照片</el-button>
              <input
                ref="identityPhotoInput2"
                type="file"
                accept=".jpg,.jpeg,.png"
                style="display: none"
                @change="onIdentityPhotoPicked($event, 2)"
              />
            </div>
          </div>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="签约状态" prop="signStatus">
              <el-select v-model="editForm.signStatus" placeholder="请选择签约状态" style="width: 100%">
                <el-option
                  v-for="item in signStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人脸认证状态" prop="faceAuthStatus">
              <el-select v-model="editForm.faceAuthStatus" placeholder="请选择人脸认证状态" style="width: 100%">
                <el-option
                  v-for="item in faceAuthStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="人脸认证有效期" prop="faceAuthValidUntil">
              <el-date-picker
                v-model="editForm.faceAuthValidUntil"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择人脸认证有效期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="签约时间" prop="contractSignAt">
              <el-date-picker
                v-model="editForm.contractSignAt"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择签约时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <el-input :value="editForm.createdAtStr" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="更新时间">
              <el-input :value="editForm.updatedAtStr" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="editSaving" @click="handleEditSave">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量修改自由职业者"
      :visible.sync="batchUpdateDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="batch-update-tip">
        <p class="batch-update-tip-line">1. 点击"下载模板"获取 Excel 模板（含列头说明与状态下拉）；</p>
        <p class="batch-update-tip-line">2. 按"证件号 + 商户 + 服务商"定位要修改的行，仅填写需要修改的列，空白列不修改（新增行姓名必填）；</p>
        <p class="batch-update-tip-line">3. 上传 .xlsx 文件提交，单次最多 1000 行、文件不超过 5MB，证件类型与证件照片不可修改；</p>
        <p class="batch-update-tip-line">4. 定位不到的数据，若其商户+服务商在系统中存在，将作为新增记录入库；商户+服务商不存在的新增行会失败。</p>
      </div>
      <div class="batch-update-actions">
        <el-button
          size="small"
          type="primary"
          plain
          icon="el-icon-download"
          :loading="templateLoading"
          @click="handleDownloadTemplate"
        >下载模板</el-button>
      </div>
      <el-upload
        ref="batchUpdateUpload"
        class="batch-update-upload"
        action=""
        accept=".xlsx"
        :auto-upload="false"
        :limit="1"
        :file-list="batchUpdateFileList"
        :on-change="onBatchUpdateFileChange"
        :on-remove="onBatchUpdateFileRemove"
        :on-exceed="onBatchUpdateFileExceed"
      >
        <el-button size="small" slot="trigger">选取文件</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchUpdateDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="batchUpdating" @click="submitBatchUpdate">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量修改结果"
      :visible.sync="batchUpdateResultVisible"
      width="560px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="batch-update-summary">
        <span>总行数：{{ batchUpdateResult.totalRows || 0 }}</span>
        <span class="batch-update-success">成功：{{ batchUpdateResult.successCount || 0 }}</span>
        <span class="batch-update-fail">失败：{{ batchUpdateResult.failCount || 0 }}</span>
      </div>
      <el-table
        v-if="batchUpdateResult.failList && batchUpdateResult.failList.length"
        :data="batchUpdateResult.failList"
        size="small"
        border
        max-height="300"
        style="width: 100%"
      >
        <el-table-column prop="row" label="行号" width="90" align="center" />
        <el-table-column prop="reason" label="失败原因" min-width="240" show-overflow-tooltip />
      </el-table>
      <p v-else class="batch-update-all-success">全部修改成功</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="batchUpdateResultVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination';
import { freelancerslist, deleteFreelancer, batchDeleteFreelancers, getFreelancerFaceAuthUrl, updateOmsFreelancer, batchUpdateFreelancerTemplate, batchUpdateFreelancers, uploadOmsIdentityPhoto, checkphoto } from '../../api/userMG';

const SIGN_STATUS_LIST = [
  { label: '待签约', value: 0 },
  { label: '签约失败', value: 1 },
  { label: '任务待领取', value: 2 },
  { label: '签约成功', value: 3 },
  { label: '待人工审核', value: 4 },
  { label: '签约实效', value: 5 }
];

const ID_TYPE_OPTIONS = [
  { label: '身份证', value: 1 },
  { label: '护照', value: 2 },
  { label: '港澳居民来内地通行证', value: 3 },
  { label: '台湾居民来内地通行证', value: 4 },
  { label: '军官证', value: 5 }
];

const VERIFICATION_STATUS_OPTIONS = [
  { label: '认证失败', value: 1 },
  { label: '未认证', value: 2 },
  { label: '认证成功', value: 3 },
  { label: '待审核', value: 4 },
  { label: '人脸识别成功', value: 5 },
  { label: '未识别', value: 6 },
  { label: '认证中', value: 7 }
];

const EDIT_SIGN_STATUS_OPTIONS = [
  { label: '待签约', value: 0 },
  { label: '签约失败', value: 1 },
  { label: '拒签', value: 2 },
  { label: '签约成功', value: 3 },
  { label: '待人工审核', value: 4 },
  { label: '签约失效', value: 5 },
  { label: '签约中', value: 6 }
];

const FACE_AUTH_STATUS_OPTIONS = [
  { label: '未认证', value: 0 },
  { label: '认证中', value: 1 },
  { label: '认证成功', value: 2 },
  { label: '认证失败', value: 3 },
  { label: '认证过期', value: 4 }
];

function createDefaultForm() {
  return {
    page: 1,
    pageSize: 10,
    name: '',
    idNumber: '',
    mobile: '',
    idType: '',
    verificationStatus: '',
    faceAuthStatus: '',
    receiveAccount: '',
    merchantName: '',
    distributeCompanyName: '',
    isPortraitPhoto: '',
    isIdentityPhoto: '',
    signStatus: '',
    faceAuthExpireDays: '',
    updatedStartDate: '',
    updatedEndDate: '',
    signAtStartDate: '',
    signAtEndDate: '',
    signDate: []
  };
}

export default {
  name: 'OmsFreelancerList',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      batchDeleting: false,
      multipleSelection: [],
      formInline: createDefaultForm(),
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      signStatusList: SIGN_STATUS_LIST,
      idTypeOptions: ID_TYPE_OPTIONS,
      verificationStatusOptions: VERIFICATION_STATUS_OPTIONS,
      signStatusOptions: EDIT_SIGN_STATUS_OPTIONS,
      faceAuthStatusOptions: FACE_AUTH_STATUS_OPTIONS,
      faceAuthDialogVisible: false,
      faceAuthLink: '',
      faceAuthError: '',
      editDialogVisible: false,
      editSaving: false,
      identityPhotoUploading1: false,
      identityPhotoUploading2: false,
      editForm: {
        id: null,
        freelancerName: '',
        identityDocumentType: null,
        identityDocumentNumber: '',
        mobile: '',
        receiveAccount: '',
        verificationStatus: null,
        signStatus: null,
        faceAuthStatus: null,
        faceAuthValidUntil: '',
        remark: '',
        contractSignAt: '',
        merchantName: '',
        distributeCompanyName: '',
        createdAtStr: '',
        updatedAtStr: '',
        identityPhoto1Url: '',
        identityPhoto2Url: '',
        identityPhoto1New: '',
        identityPhoto2New: ''
      },
      editRules: {
        freelancerName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        identityDocumentType: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        identityDocumentNumber: [
          { required: true, message: '请输入证件号', trigger: 'blur' }
        ]
      },
      batchUpdateDialogVisible: false,
      batchUpdateResultVisible: false,
      batchUpdating: false,
      templateLoading: false,
      batchUpdateFileList: [],
      batchUpdateResult: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    buildQueryParams() {
      const params = { ...this.formInline };
      params.signAtStartDate = (params.signDate && params.signDate[0]) || '';
      params.signAtEndDate = (params.signDate && params.signDate[1]) || '';
      return params;
    },
    getList() {
      this.loading = true;
      freelancerslist(this.buildQueryParams())
        .then((res) => {
          if (res && res.msg === 'success') {
            const data = res.data || {};
            this.listData = data.items || data.list || data.records || [];
            this.pageparm.total = data.totalCount || data.total || data.count || 0;
            this.pageparm.page = data.page || this.formInline.page;
            this.pageparm.pageSize = data.pageSize || this.formInline.pageSize;
          } else {
            this.listData = [];
            this.pageparm.total = 0;
            this.$message.error((res && (res.msg || res.message)) || '获取自由职业者列表失败');
          }
        })
        .catch((err) => {
          this.listData = [];
          this.pageparm.total = 0;
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取自由职业者列表失败');
        })
        .finally(() => {
          this.loading = false;
          this.multipleSelection = [];
          if (this.$refs.freelancerTable) {
            this.$refs.freelancerTable.clearSelection();
          }
        });
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection || [];
    },
    handleBatchDelete() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选要删除的自由职业者');
        return;
      }
      const count = this.multipleSelection.length;
      this.$confirm(`确定删除勾选的 ${count} 条自由职业者吗？删除后不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.batchDeleting = true;
          const ids = this.multipleSelection.map((item) => item.id);
          batchDeleteFreelancers(ids)
            .then((res) => {
              if (res && res.msg === 'success') {
                const deleted = res.data != null ? res.data : count;
                this.$message.success(`成功删除 ${deleted} 条自由职业者`);
                this.getList();
              } else {
                this.$message.error((res && (res.msg || res.message)) || '批量删除失败');
              }
            })
            .catch((err) => {
              const data = err && err.response && err.response.data;
              this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '批量删除失败');
            })
            .finally(() => {
              this.batchDeleting = false;
            });
        })
        .catch(() => {});
    },
    search() {
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline = createDefaultForm();
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '--';
      const timestampMs = String(timestamp).length <= 10 ? timestamp * 1000 : timestamp;
      const date = new Date(timestampMs);
      if (Number.isNaN(date.getTime())) return '--';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    getSignStatusColor(status) {
      switch (status) {
        case 0:
        case 6:
          return '#409EFF';
        case 3:
          return '#67C23A';
        case 5:
          return '#909399';
        case 1:
        case 2:
          return '#F56C6C';
        case 4:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    getVerificationStatusColor(status) {
      switch (status) {
        case 2:
        case 7:
          return '#409EFF';
        case 3:
          return '#67C23A';
        case 6:
          return '#909399';
        case 1:
          return '#F56C6C';
        case 4:
        case 5:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    getFaceAuthStatusColor(faceAuthStatus) {
      switch (faceAuthStatus) {
        case 0:
        case 1:
          return '#409EFF';
        case 2:
          return '#67C23A';
        case 3:
          return '#F56C6C';
        case 4:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    // 日期口径与客户端一致：有效期当天全天有效，次日起算过期
    isFaceAuthExpired(row) {
      const validUntil = row && row.faceAuthValidUntil;
      if (!validUntil) return false;
      const expireDate = new Date(String(validUntil).replace(/-/g, '/'));
      if (Number.isNaN(expireDate.getTime())) return false;
      expireDate.setHours(23, 59, 59, 999);
      return Date.now() > expireDate.getTime();
    },
    // 显示口径：状态码4无条件算认证过期；状态码2且有效期已过也算认证过期
    isFaceAuthDisplayExpired(row) {
      if (!row) return false;
      if (row.faceAuthStatus === 4) return true;
      return row.faceAuthStatus === 2 && this.isFaceAuthExpired(row);
    },
    getFaceAuthStatusDisplayText(row) {
      if (this.isFaceAuthDisplayExpired(row)) {
        return '认证过期';
      }
      return (row && row.faceAuthStatusStr) || '--';
    },
    getFaceAuthStatusDisplayColor(row) {
      if (this.isFaceAuthDisplayExpired(row)) {
        return '#F56C6C';
      }
      return this.getFaceAuthStatusColor(row && row.faceAuthStatus);
    },
    handleFaceAuth(row) {
      const freelancerId = row && row.freelancerId;
      if (!freelancerId) {
        this.$message.warning('记录信息不完整，无法获取人脸认证链接');
        return;
      }
      this.$set(row, 'faceAuthLoading', true);
      getFreelancerFaceAuthUrl(freelancerId)
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.faceAuthLink = res.data;
            this.faceAuthError = '';
          } else {
            this.faceAuthLink = '';
            this.faceAuthError = (res && (res.msg || res.message)) || '获取人脸认证链接失败';
          }
          this.faceAuthDialogVisible = true;
        })
        .catch((err) => {
          this.faceAuthLink = '';
          const data = err && err.response && err.response.data;
          this.faceAuthError = (data && (data.msg || data.message)) || (err && err.message) || '获取人脸认证链接失败';
          this.faceAuthDialogVisible = true;
        })
        .finally(() => {
          this.$set(row, 'faceAuthLoading', false);
        });
    },
    handleCopyFaceAuthLink() {
      if (!this.faceAuthLink) return;
      this.copyToClipboard(this.faceAuthLink);
    },
    handleDelete(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录信息不完整，无法删除');
        return;
      }
      const name = row.freelancerName || '该自由职业者';
      this.$confirm(`确定删除自由职业者「${name}」吗？删除后不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$set(row, 'deleting', true);
          deleteFreelancer({ id: row.id })
            .then((res) => {
              if (res && res.msg === 'success') {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error((res && (res.msg || res.message)) || '删除失败');
              }
            })
            .catch((err) => {
              const data = err && err.response && err.response.data;
              this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '删除失败');
            })
            .finally(() => {
              this.$set(row, 'deleting', false);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录信息不完整，无法修改');
        return;
      }
      this.editForm = {
        id: row.id,
        freelancerName: row.freelancerName || '',
        identityDocumentType: row.identityDocumentType != null ? row.identityDocumentType : null,
        identityDocumentNumber: row.identityDocumentNumber || '',
        mobile: row.mobile || '',
        receiveAccount: row.receiveAccount || '',
        verificationStatus: row.verificationStatus != null ? row.verificationStatus : null,
        signStatus: row.signStatus != null ? row.signStatus : null,
        faceAuthStatus: row.faceAuthStatus != null ? row.faceAuthStatus : null,
        faceAuthValidUntil: row.faceAuthValidUntil || '',
        remark: row.remark || '',
        contractSignAt: row.contractSignAtStr || row.contractSignAt || '',
        merchantName: row.merchantName || '',
        distributeCompanyName: row.distributeCompanyName || '',
        createdAtStr: row.createdAtStr || (row.createdAt ? this.formatDateTime(row.createdAt) : ''),
        updatedAtStr: row.updatedAtStr || (row.updatedAt ? this.formatDateTime(row.updatedAt) : ''),
        identityPhoto1Url: '',
        identityPhoto2Url: '',
        identityPhoto1New: '',
        identityPhoto2New: ''
      };
      this.editDialogVisible = true;
      this.loadIdentityPhotos(row.freelancerId);
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate();
        }
      });
    },
    loadIdentityPhotos(freelancerId) {
      this.editForm.identityPhoto1Url = '';
      this.editForm.identityPhoto2Url = '';
      if (!freelancerId) return;
      checkphoto({ identityDocumentNumber: freelancerId })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.editForm.identityPhoto1Url = res.data.identityPhoto1Url || '';
            this.editForm.identityPhoto2Url = res.data.identityPhoto2Url || '';
          }
        })
        .catch(() => {});
    },
    pickIdentityPhoto(side) {
      const input = this.$refs['identityPhotoInput' + side];
      if (input) {
        input.value = '';
        input.click();
      }
    },
    onIdentityPhotoPicked(event, side) {
      const input = event && event.target;
      const file = input && input.files && input.files[0];
      if (!file) return;
      if (!this.isLegalIdentityPhoto(file)) return;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('photoSide', side);
      if (side === 1) {
        this.identityPhotoUploading1 = true;
      } else {
        this.identityPhotoUploading2 = true;
      }
      uploadOmsIdentityPhoto(this.editForm.id, formData)
        .then((res) => {
          if (res && res.code === 0 && res.data && res.data.objectName) {
            this.editForm['identityPhoto' + side + 'Url'] = URL.createObjectURL(file);
            this.editForm['identityPhoto' + side + 'New'] = res.data.objectName;
            this.$message.success('照片上传成功，保存后生效');
          } else {
            this.$message.error((res && (res.msg || res.message)) || '照片上传失败');
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '照片上传失败');
        })
        .finally(() => {
          if (side === 1) {
            this.identityPhotoUploading1 = false;
          } else {
            this.identityPhotoUploading2 = false;
          }
        });
    },
    isLegalIdentityPhoto(file) {
      const name = (file && file.name) || '';
      const lowerName = name.toLowerCase();
      if (!/\.(jpg|jpeg|png)$/.test(lowerName)) {
        this.$message.warning('仅支持 jpg、jpeg、png 格式照片');
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning('照片大小不能超过5MB');
        return false;
      }
      return true;
    },
    handleEditSave() {
      if (this.identityPhotoUploading1 || this.identityPhotoUploading2) {
        this.$message.warning('照片正在上传，请稍候再保存');
        return;
      }
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.editSaving = true;
        const payload = {
          freelancerName: this.editForm.freelancerName,
          identityDocumentType: this.editForm.identityDocumentType,
          identityDocumentNumber: this.editForm.identityDocumentNumber,
          mobile: this.editForm.mobile || '',
          receiveAccount: this.editForm.receiveAccount || '',
          verificationStatus: this.editForm.verificationStatus,
          signStatus: this.editForm.signStatus,
          faceAuthStatus: this.editForm.faceAuthStatus,
          faceAuthValidUntil: this.editForm.faceAuthValidUntil || null,
          remark: this.editForm.remark || '',
          contractSignAt: this.editForm.contractSignAt || null
        };
        if (this.editForm.identityPhoto1New) {
          payload.identityPhoto1 = this.editForm.identityPhoto1New;
        }
        if (this.editForm.identityPhoto2New) {
          payload.identityPhoto2 = this.editForm.identityPhoto2New;
        }
        updateOmsFreelancer(this.editForm.id, payload)
          .then((res) => {
            if (res && res.msg === 'success') {
              this.$message.success('修改成功');
              this.editDialogVisible = false;
              this.getList();
            } else {
              this.$message.error((res && (res.msg || res.message)) || '修改失败');
            }
          })
          .catch((err) => {
            const data = err && err.response && err.response.data;
            this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '修改失败');
          })
          .finally(() => {
            this.editSaving = false;
          });
      });
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(str)
          .then(() => {
            this.$message.success('已复制');
          })
          .catch(() => {
            this.fallbackCopy(str);
          });
      } else {
        this.fallbackCopy(str);
      }
    },
    openBatchUpdateDialog() {
      this.batchUpdateFileList = [];
      this.batchUpdateResult = {};
      if (this.$refs.batchUpdateUpload) {
        this.$refs.batchUpdateUpload.clearFiles();
      }
      this.batchUpdateDialogVisible = true;
    },
    handleDownloadTemplate() {
      this.templateLoading = true;
      batchUpdateFreelancerTemplate()
        .then((blob) => {
          if (!blob || !(blob instanceof Blob)) {
            this.$message.error('模板下载失败');
            return;
          }
          const href = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.download = '自由职业者批量修改模板.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
        .catch(() => {
          this.$message.error('模板下载失败，请重试');
        })
        .finally(() => {
          this.templateLoading = false;
        });
    },
    onBatchUpdateFileChange(file) {
      const fileName = (file && file.name) || '';
      if (fileName && !fileName.toLowerCase().endsWith('.xlsx')) {
        this.$message.warning('仅支持 .xlsx 格式文件');
        this.batchUpdateFileList = [];
        if (this.$refs.batchUpdateUpload) {
          this.$refs.batchUpdateUpload.clearFiles();
        }
        return;
      }
      // 手动上传模式(before-upload 不触发)，选文件时校验大小，超大文件直接拦下
      const fileSize = (file && file.size) || (file && file.raw && file.raw.size) || 0;
      if (fileSize > 5 * 1024 * 1024) {
        this.$message.warning('文件大小不能超过 5MB，请拆分后重试');
        this.batchUpdateFileList = [];
        if (this.$refs.batchUpdateUpload) {
          this.$refs.batchUpdateUpload.clearFiles();
        }
        return;
      }
      this.batchUpdateFileList = file && file.raw ? [{ name: file.name, raw: file.raw }] : [];
    },
    onBatchUpdateFileRemove() {
      this.batchUpdateFileList = [];
    },
    onBatchUpdateFileExceed() {
      this.$message.warning('只能选择一个文件，请先移除已选文件');
    },
    submitBatchUpdate() {
      if (!this.batchUpdateFileList.length) {
        this.$message.warning('请先选择 .xlsx 文件');
        return;
      }
      const raw = this.batchUpdateFileList[0].raw;
      const fileName = (raw && raw.name) || '';
      if (!fileName.toLowerCase().endsWith('.xlsx')) {
        this.$message.warning('仅支持 .xlsx 格式文件');
        return;
      }
      this.batchUpdating = true;
      const formData = new FormData();
      formData.append('file', raw);
      batchUpdateFreelancers(formData)
        .then((res) => {
          if (res && res.msg === 'success') {
            const data = res.data || {};
            this.batchUpdateResult = data;
            this.batchUpdateResultVisible = true;
            this.batchUpdateDialogVisible = false;
            this.$message.success(`批量修改完成：成功 ${data.successCount || 0} 行，失败 ${data.failCount || 0} 行`);
            if ((data.successCount || 0) > 0) {
              this.getList();
            }
          } else {
            this.$message.error((res && (res.msg || res.message)) || '批量修改失败');
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '批量修改失败');
        })
        .finally(() => {
          this.batchUpdating = false;
        });
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>
.freelancer-list-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.search-form .search-date {
  width: 240px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.batch-bar {
  margin-bottom: 16px;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.copyable-cell {
  cursor: pointer;
}
.face-auth-tip {
  margin: 0 0 8px;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}
.face-auth-error-msg {
  margin: 0;
  padding: 12px 14px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.5;
}
.batch-update-tip {
  margin-bottom: 12px;
  padding: 12px 14px;
  background: #f4f8ff;
  border: 1px solid #d9e6ff;
  border-radius: 4px;
}
.batch-update-tip-line {
  margin: 0 0 4px;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
.batch-update-tip-line:last-child {
  margin-bottom: 0;
}
.batch-update-actions {
  margin-bottom: 12px;
}
.batch-update-upload {
  margin-bottom: 4px;
}
.batch-update-summary {
  margin-bottom: 12px;
  font-size: 14px;
  color: #303133;
}
.batch-update-summary span {
  margin-right: 24px;
}
.batch-update-summary .batch-update-success {
  color: #67c23a;
}
.batch-update-summary .batch-update-fail {
  color: #f56c6c;
}
.batch-update-all-success {
  margin: 0;
  color: #67c23a;
  font-size: 14px;
}
.identity-photo-area {
  display: flex;
}
.identity-photo-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 24px;
}
.identity-photo-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}
.identity-photo-thumb {
  width: 120px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  margin-bottom: 6px;
  cursor: pointer;
}
.identity-photo-empty {
  width: 120px;
  height: 80px;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 12px;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/freelancerList.vue